import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=1f2ee7df"
import script from "./TagIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TagIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports